import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_213: DocMigration = {
  maxSchemaVersion: "0.0.213",
  description: "Migrate radial window grid settings to separate props",
  apply(json: any) {
    function addRadialSettings(setting) {
      if (!setting) {
        return;
      }
      if (setting.mullionType === "RADIAL_CUSTOM") {
        if (setting.paneOneXLayout) {
          setting.paneOneRadialLayout = setting.paneOneXLayout;
        }
        if (setting.paneOneYLayout) {
          setting.paneOneCircularLayout = setting.paneOneYLayout;
        }
      }
    }

    // update settings
    for (const settingId in json.settings) {
      const setting = json.settings[settingId];
      if (setting.type === "WINDOW_MULLION_SETTINGS") {
        addRadialSettings(setting);
        continue;
      }
      if (setting.type === "WINDOW_CATALOG_SETTINGS") {
        for (const windowTypeId in setting.windowTypes) {
          const windowType = setting.windowTypes[windowTypeId];
          addRadialSettings(windowType?.mullions);
        }
      }
    }

    // update instances
    for (const openingId in json.openings) {
      const opening = json.openings[openingId];
      addRadialSettings(opening?.mullions);
    }

    for (const openingId in json.gableOpenings) {
      const opening = json.gableOpenings[openingId];
      addRadialSettings(opening?.mullions);
    }

    for (const openingId in json.dormers) {
      const opening = json.dormers[openingId];
      addRadialSettings(opening?.mullions);
    }

    return json;
  },
};

export default migration_0_0_213;
